import { CREATININE_CONVERSION, SERUM_MG_DL } from './constants';

export function calculateAdjustedBodyWeight({ibw, actualBodyWeightKg}) {
  if (!ibw || !actualBodyWeightKg) {
    return null;
  }  
  return ibw + 0.4 * (actualBodyWeightKg - ibw);
}

export function calculateBmi({heightCm, actualBodyWeightKg}) {
  if (!heightCm || !actualBodyWeightKg) {
    return null;
  }  
  return actualBodyWeightKg / Math.pow(heightCm / 100, 2);
}

export function normaliseCreatinine(value, unit = "micromoles/L") {
  if (unit === "millimoles/L") return value * 1000;
  if (unit === SERUM_MG_DL) return value * CREATININE_CONVERSION.MG_DL_TO_MICROMOL_L;
  return value;
}

export function calculateCrCl({ age, sex, weightKg, serumCreatinineMicromol }) {
  const cr = serumCreatinineMicromol * 0.001;
  let clearance = ((140 - age) * weightKg) / (814 * cr);
  if (sex === "Female") clearance = clearance * 0.85;

  return clearance; // return full precision for internal calculations
}

// UI-specific version that applies rounding for display
export function calculateCrClForDisplay({ age, sex, weightKg, serumCreatinineMicromol }) {
  const clearance = calculateCrCl({ age, sex, weightKg, serumCreatinineMicromol });
  
  const roundedClearance = Math.round(clearance * 100) / 100;
  const decimalPart = roundedClearance - Math.floor(roundedClearance);
  if (decimalPart < 0.5) {
    return Math.floor(roundedClearance);
  } else {
    return Math.ceil(roundedClearance);
  }
}

export function convertLength(value, fromUnit, toUnit) {
  const num = Number(value);
  if (!Number.isFinite(num)) return null;
  if (fromUnit === toUnit) return num;
  if (fromUnit === 'in' && toUnit === 'cm') return num * 2.54;
  if (fromUnit === 'cm' && toUnit === 'in') return num / 2.54;
  return null;
}

export function rounding(number, decimal) {
  return Math.round(number * (10 ** decimal)) / (10 ** decimal);
}

export function roundOne(number) {
  return rounding(number, 1);
}

